import { createAction, props } from '@ngrx/store';
import { ChangeParamsPayload, FailPayload, SuccessListResponse } from '@store/_common/models/common.types';
import { Customer } from '@features/profile/models/customer';

const loading = createAction('[Consents] List consents loading');
const failed = createAction('[Consents] List consents failed', props<FailPayload>());
const loaded = createAction('[Consents] List  consents success', props<SuccessListResponse<Customer>>());
const updateParams = createAction('[Consents] List consents update params', props<ChangeParamsPayload>());
const clearParams = createAction('[Consents] List consents clear params');
const failedFiltersLoad = createAction('[Settlements] Load filters failed', props<FailPayload>());
const loadedFilters = createAction('[Settlements] Load filters success');

export const consentListActions = {
  failed,
  loading,
  loaded,
  updateParams,
  clearParams,
  failedFiltersLoad,
  loadedFilters,
};
